import axios from "axios";
import {useAuthStore} from "@/store/auth/index.js";
import {i18n} from "@/i18n";

// Create a custom Axios instance
const axiosInstance = axios.create();

// Set the Bearer token for this instance
const token = localStorage.getItem('jwtToken');
if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
} else {
    delete axiosInstance.defaults.headers.common['Authorization'];
}

axiosInstance.defaults.baseURL =
    import.meta.env.VITE_API_BASE_URL || 'https://api.prayerapp.me';
axiosInstance.defaults.withCredentials = true

// The API writes generated text (ayah cards…) in the site's language.
axiosInstance.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = i18n.global.locale.value;
    return config;
});

axiosInstance.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response) {
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
    } else if (error.request) {
        console.error('Error request:', error.request);
    } else {
        console.error('Error message:', error.message);
    }
    console.error('Error config:', error.config);
    // Samo 401 = sesija/token ne važi. Ostale greške (mreža, 404, 500…) ne smeju
    // da izbace korisnika — javne stranice i hero pozivaju API bez prijave.
    // A wrong password on the sign-in form is a 401 too; that one is the form's to show.
    const url = error.config?.url ?? '';
    if (error.response?.status === 401 && !/\/api\/(login|auth\/logout)$/.test(url)) {
        const auth = useAuthStore();
        if (auth.isAuthenticated) {
            auth.logout({ remote: false, redirect: location.pathname + location.search });
        }
    }
    return Promise.reject(error);
});

export default axiosInstance;
